module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "landing-page"
  }, [_c('landing-header'), _vm._v(" "), _c('landing-hero', {
    attrs: {
      "id": "inicio"
    }
  }), _vm._v(" "), _c('landing-testimonials', {
    attrs: {
      "id": "depoimentos"
    }
  }), _vm._v(" "), _c('landing-clients', {
    attrs: {
      "id": "clientes"
    }
  }), _vm._v(" "), _c('landing-how-we-work', {
    attrs: {
      "id": "como-trabalhamos"
    }
  }), _vm._v(" "), _c('landing-office', {
    attrs: {
      "id": "escritorio"
    }
  }), _vm._v(" "), _c('landing-github', {
    attrs: {
      "id": "open-source"
    }
  }), _vm._v(" "), _c('landing-workable', {
    attrs: {
      "id": "vagas"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a09ea43e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = 147
// module chunks = 1